// The name of the school a signed-out visitor is joining (from the pending join the landing saved),
// so sign-up and log-in keep the school in view. No network call; null when there is no pending join.
import { useEffect, useState } from "react";

import { pendingJoin } from "./pendingJoin";

export function useJoiningSchool(): string | null {
  const [name, setName] = useState<string | null>(null);
  useEffect(() => {
    let live = true;
    void pendingJoin.read().then((p) => live && setName(p?.schoolName ?? null));
    return () => {
      live = false;
    };
  }, []);
  return name;
}
